import React, { useState, useEffect } from 'react';
import { useTranslate } from '@awardit/react-use-translate';
import { Slider, Input } from '@crossroads/ui-components';
import cn from 'classnames';
import styles from 'shop-views/PointSelection.scss';

var PointSelection = _ref => {
  var balance = _ref.balance,
      PointsTooltip = _ref.PointsTooltip,
      remainingPrice = _ref.remainingPrice,
      points = _ref.points,
      setPoints = _ref.setPoints,
      minValue = _ref.minValue,
      maxValue = _ref.maxValue,
      formatPrice = _ref.formatPrice,
      formatPoints = _ref.formatPoints,
      isProcessing = _ref.isProcessing;
  var t = useTranslate();

  var _useState = useState(points.toString()),
      input = _useState[0],
      setInput = _useState[1];

  useEffect(() => {
    setInput(points.toString());
  }, [points]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("header", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("h3", {
    className: styles.heading
  }, t("CHECKOUT.PART_PAYMENT.POINTS_TITLE")), PointsTooltip !== undefined && PointsTooltip), /*#__PURE__*/React.createElement("p", {
    className: styles.subHeading
  }, t("CHECKOUT.PART_PAYMENT.POINTS_BALANCE", {
    points: formatPoints ? formatPoints(balance) : ""
  })), /*#__PURE__*/React.createElement("section", {
    className: styles.body
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.pointSelect
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.slider
  }, /*#__PURE__*/React.createElement(Slider, {
    value: points,
    minValue: minValue,
    maxValue: maxValue,
    onChange: v => setPoints(v)
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.sliderLabels
  }, /*#__PURE__*/React.createElement("span", null, formatPoints ? formatPoints(minValue) : ""), /*#__PURE__*/React.createElement("span", null, formatPoints ? formatPoints(maxValue) : ""))), /*#__PURE__*/React.createElement(Input, {
    label: t("CHECKOUT.PART_PAYMENT.POINTS"),
    variant: "float",
    name: "points",
    value: input.toString(),
    onChange: e => {
      setInput(e.currentTarget.value);
    },
    onBlur: e => {
      var value = Math.min(Math.max(Number.parseInt(e.currentTarget.value, 10) || 0, minValue), maxValue);
      setPoints(value);
      setInput(value);
    }
  }))), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("footer", {
    className: cn(styles.footer, {
      [styles.processing]: isProcessing
    })
  }, /*#__PURE__*/React.createElement("h3", null, t("CHECKOUT.PART_PAYMENT.AMOUNT_TO_PAY")), /*#__PURE__*/React.createElement("h3", null, formatPoints && formatPoints(points), remainingPrice !== undefined && remainingPrice > 0 && /*#__PURE__*/React.createElement("span", {
    className: styles.remainder
  }, "+ ", formatPrice(remainingPrice)))));
};

export default PointSelection;
//# sourceMappingURL=index.js.map
